import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import { Drawer, Typography, Button, Icon, Loader } from "@perxis-auto/ui-kit";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import clsx from "clsx";
import styles from "./FinanceDrawer.module.scss.js";
function FinanceDrawer({ title, onClose, children, open = true, rootClassName, ...props }) {
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      open,
      styles: { header: { display: "none" } },
      placement: "left",
      onClose,
      rootClassName: clsx(styles.financeDrawer, rootClassName),
      ...props,
      children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-green"], className: styles.financeDrawer__inner, children: [
        /* @__PURE__ */ jsxs(Col, { span: 24, flex: "0 0 auto", children: [
          /* @__PURE__ */ jsx(Typography.Title, { level: "h2", headingLevel: 3, className: styles.financeDrawer__title, children: title }),
          /* @__PURE__ */ jsx(Button, { type: "text", onClick: onClose, className: styles.financeDrawer__closeButton, children: /* @__PURE__ */ jsx(Icon, { name: "cross", size: 36, sticker: "finance-drawer-cross-icon" }) })
        ] }),
        /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, { size: "large", className: styles.financeDrawer__loader }), children })
      ] })
    }
  );
}
export {
  FinanceDrawer
};
